module.exports = __webpack_public_path__ + "img/Artboard 1_4.jpg";